import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-delegieren';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentDelegierenEffects {

    IncidentDelegieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_DELEGIEREN),
        mergeMap((x: ac.PostIncidentDelegierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentDelegieren(x.incidentDelegationRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentDelegierenErfolgreichAction(result, x.incidentDelegationRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentDelegierenFehlerAction(error, x.incidentDelegationRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
